import { useState, useEffect } from 'react';
import { Gql } from '@fiverr-private/loyalty_utils';
import { BannerType, PayloadGigInfo } from './bannerPropsTypes';

export const useShouldShowBanner = ({
    gigInfo,
    loyaltyIndicationData,
    type,
}: {
    gigInfo: PayloadGigInfo;
    loyaltyIndicationData: Gql.EngagementBadgeInfo;
    type: BannerType;
}): boolean => {
    const [shouldShow, setShouldShow] = useState(false);

    useEffect(() => {
        if (!loyaltyIndicationData) {
            return;
        }

        const { orderEntitledForCredit, amountOver = 0, tier } = loyaltyIndicationData;
        const { gigPriceInUSDCents, isProSeller, showBanner } = gigInfo;

        let show = false;

        if (tier === Gql.LoyaltyProgramTier.Silver && type === 'orders_page') {
            return;
        }

        if (orderEntitledForCredit === Gql.OrderEntitledForCredit.AlreadyUsed) {
            return;
        }

        if (
            (type === 'freelancer_page' &&
                loyaltyIndicationData.tier === Gql.LoyaltyProgramTier.Gold &&
                gigInfo.isProSeller) ||
            (type === 'freelancer_page' && loyaltyIndicationData.tier === Gql.LoyaltyProgramTier.Platinum)
        ) {
            setShouldShow(true);
            return;
        }

        if (
            (type === 'agency_page' &&
                loyaltyIndicationData.tier === Gql.LoyaltyProgramTier.Gold &&
                gigInfo.isProAgency) ||
            (type === 'agency_page' && loyaltyIndicationData.tier === Gql.LoyaltyProgramTier.Platinum)
        ) {
            setShouldShow(true);
            return;
        }

        if (type === 'listings' && loyaltyIndicationData.tier !== Gql.LoyaltyProgramTier.Silver && showBanner) {
            setShouldShow(true);
            return;
        }

        if (
            type === 'custom_offer' &&
            ((loyaltyIndicationData.tier === Gql.LoyaltyProgramTier.Silver &&
                gigInfo.gigPriceInUSDCents >= (amountOver || 0)) ||
                (loyaltyIndicationData.tier === Gql.LoyaltyProgramTier.Gold && gigInfo.isProSeller) ||
                loyaltyIndicationData.tier === Gql.LoyaltyProgramTier.Platinum)
        ) {
            setShouldShow(true);
            return;
        }

        if (
            type === 'hourly_offer' &&
            ((loyaltyIndicationData.tier === Gql.LoyaltyProgramTier.Gold && gigInfo.isProSeller) ||
                loyaltyIndicationData.tier === Gql.LoyaltyProgramTier.Platinum)
        ) {
            setShouldShow(true);
            return;
        }

        if (orderEntitledForCredit === Gql.OrderEntitledForCredit.EveryOrder) {
            show = true;
        }

        if (orderEntitledForCredit === Gql.OrderEntitledForCredit.FirstOrderOverAmount) {
            show = type === 'payments_page' ? true : Boolean(gigPriceInUSDCents >= (amountOver || 0));
        }

        if (orderEntitledForCredit === Gql.OrderEntitledForCredit.EachProSeller) {
            show = !!isProSeller;
        }

        if (show && type === 'payments_page') {
            show = true;
        }

        setShouldShow(show);
    }, [loyaltyIndicationData, gigInfo, type]);

    return shouldShow;
};
